import { Link, useNavigate, useParams } from '@tanstack/react-router';
import { ArrowLeft, ExternalLink } from 'lucide-react';
import { useChallengeForDiffusion } from '@/features/challenge-reel/use-challenge-reel';
import { ChallengeReelCard } from '@/features/challenge-reel/challenge-reel-card';
import { ChallengeManageCard } from '@/features/challenge-reel/challenge-manage-card';

export function TutorAdminChallengeDiffusionPage() {
  const { challengeId } = useParams({ strict: false }) as { challengeId: string };
  const { data: challenge, isLoading } = useChallengeForDiffusion(challengeId);
  const navigate = useNavigate();

  const marketingUrl =
    (import.meta.env.VITE_MARKETING_URL as string | undefined) ?? 'https://jeraisonne.fr';

  return (
    <div className="mx-auto max-w-2xl p-4 sm:p-6">
      <Link
        to="/tutor/admin/challenges"
        className="text-ink-500 hover:text-ink-900 mb-4 inline-flex items-center gap-1.5 font-sans text-[13px] transition-colors"
      >
        <ArrowLeft className="h-4 w-4" />
        Défis
      </Link>

      {isLoading ? (
        <div className="bg-ink-100 h-64 animate-pulse rounded-2xl" />
      ) : !challenge ? (
        <p className="text-ink-500 font-sans text-sm">Défi introuvable.</p>
      ) : (
        <>
          <div className="mb-4">
            <h1 className="font-display text-ink-900 text-2xl font-extrabold tracking-tight">
              {challenge.title}
            </h1>
            <a
              href={`${marketingUrl.replace(/\/$/, '')}/challenge/${challenge.slug}`}
              target="_blank"
              rel="noreferrer"
              className="text-primary-600 mt-1 inline-flex items-center gap-1 font-sans text-xs font-bold"
            >
              <ExternalLink className="h-3.5 w-3.5" /> Voir le défi
            </a>
          </div>
          <ChallengeManageCard
            challenge={challenge}
            onDeleted={() => navigate({ to: '/tutor/admin/challenges' })}
          />
          <ChallengeReelCard challenge={challenge} />
        </>
      )}
    </div>
  );
}
